import { Calculator } from '@dynameat/views/reporting/models';
import { ProcessingSpeedQuery } from '../queries';
import { PROCESSING_SPEED } from '../constants';

export class ProcessingSpeedCalculator extends Calculator {
  kpiType = PROCESSING_SPEED

  MAX_PROCESSING = 3

  SCALE = 2

  constructor(productGuid) {
    super();
    this.productGuid = productGuid;
  }

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(ProcessingSpeedQuery, this.productGuid);
    const props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][0]);
    return this.getModelToInstance(props);
  }

  executeUncubeQuery(queryClass, productGuid) {
    // eslint-disable-next-line new-cap
    const uncubeQuery = new queryClass(productGuid);
    return uncubeQuery.execute();
  }

  getDataIfNoPreviousPeriod(currentRawKpi) {
    const currentKpi = this.getValueOfKpi(currentRawKpi);
    return {
      key: this.productGuid,
      kpi: currentKpi,
      increment: null,
      type: this.kpiType,
    };
  }

  getValueOfKpi(rawKpi) {
    if (!Number.isNaN(rawKpi)) {
      const scaledFloat = (rawKpi * this.SCALE) / this.MAX_PROCESSING;
      return Math.trunc(scaledFloat);
    }
    return 0;
  }
}
